
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CNotification"
})
export default class CNotification extends Vue {}
